// This file is generated and hand-edited. Source of truth for the "features" namespace.
// See docs/locales.md for naming conventions and tooling.

export const features = {
  adminSettings: {
    menu: {
      general: {
        sections: {
          software: "Software",
          development: "Development",
          locales: "Locales",
          calendar: "Calendar",
          shortcuts: "Shortcuts",
          messaging: "Messaging",
          notifications: "Notifications",
          errors: "Errors",
        },
      },
      users: {
        title: "Users",
        sections: {
          inviteRoles: "Invite Roles & Specializations",
        },
      },
      flowsConfigurator: {
        title: "Flows Configurator",
        description: "Manage all flows in the CoTreatMe system",
        subtitle: "Treatment Plans",
        subdescription: "Manage existing treatment plans and their jobs",
        create: "Create Treatment Plan",
        sections: {
          list: "List",
        },
      },
      qrConfigurator: {
        title: "QR Code Configurator",
        description: "Manage all QR codes in the CoTreatMe system",
        subtitle: "QR codes",
        subdescription: "Manage existing QR codes",
        create: "Create new QR code",
        sections: {
          list: "List",
        },
      },
      termsAndConditions: {
        title: "Policy Documents",
        description: "Manage versioned policy documents",
        subdescription: "Create and manage documents, then add versioned content to each",
        createDocument: "New Document",
        noData: "No documents found",
        noVersions: "No versions yet",
        noCurrentVersion: "No current version",
        current: "Current",
        versions: "Versions",
        versionsDialogSubtitle: "Version history",
        addVersion: "Add Version",
        newVersion: "New Version",
        editVersion: "Edit Version v{version}",
        versionHistory: "Version History v{version}",
        viewHistory: "View History",
        promoteLabel: "Set as current version",
        deactivateLabel: "Deactivate current",
        entityDocument: "Terms Document",
        entityVersion: "Terms Version",
        noHistory: "No history entries found",
        sections: {
          list: "List",
        },
        fields: {
          content: "Content",
          version: "Version",
          createdAt: "Created At",
          historyUser: "Changed By",
        },
        historyType: {
          modified: "Modified",
          deleted: "Deleted",
        },
      },
      medical: {
        title: "Medical",
      },
      data: {
        title: "Data",
      },
      thirdparty: {
        title: "Third-party",
      },
      products: {
        title: "Products",
        sections: {
          list: "List",
        },
      },
    },
    groupPermissions: {
      title: "Groups & Permissions",
      subtitle: "Define groups by child groups and/or a set of permissions",
      detailSubtitle: "A group can be defined by child groups and/or a set of permissions",
      createGroup: "Create Group",
      groupName: "Group name",
      noGroups: "No groups found",
      definitionTitle: "Group definition",
      applicableModels: "Applicable levels",
      applicableModelsHint: "Which level this group can be assigned to",
      badgeTitle: "Badge & color",
      badgeSubtitle: "Short code, priority and color displayed on user badges",
      badgePreview: "Preview",
      hierarchyTitle: "Hierarchy",
      hierarchySubtitle: "Define this group through its parent and child groups",
      parents: "Parent groups",
      parentsHint: "Groups that inherit this group",
      children: "Child groups",
      childrenHint: "Groups this group inherits from",
      viewGraph: "Group graph",
      permissionsSubtitle: "Define this group through a set of permissions",
      childCount: "{count} child group | {count} child groups",
      role: {
        center: "Current",
        parent: "Parent",
        child: "Child",
      },
      directPermissionCount: "{count} direct permission | {count} direct permissions",
      allPermissionCount: "{count} all permission | {count} all permissions",
      directPermissionsTooltip: "Manually added permissions, not gained from child groups",
      allPermissionsTooltip: "Total of direct permissions and permissions from child groups",
      applicableModelLabels: {
        platform: "Platform-wide scope",
        mso: "MSO-wide scope",
        practice: "Practice-wide scope",
        office: "Office-wide scope",
      },
    },
  },
  analytics: {
    widgets: {
      activePatientsNetworkWidget: {
        title: "Active Patients Network",
        content: {
          subtitle: "Across {count} practices",
        },
      },
      dataQualityAlertsWidget: {
        title: "Data Quality Alerts",
        content: {
          expand: "Show All",
        },
      },
      doctorEngagementWidget: {
        title: "Doctor Engagement",
        content: {
          subtitle: "Avg. weekly active",
        },
      },
      patientConversionFunnelWidget: {
        title: "Total practices",
        content: {
          categories: {
            leads: "Leads",
            consultations: "Consultations",
            treatmentStarts: "Treatment starts",
          },
          subtitle: "Active Treatments",
        },
      },
      patientProgressionDistributionWidget: {
        title: "Patient Progression Distribution",
      },
      patientReadinessLevelsWidget: {
        title: "Patient Readiness Levels",
      },
      patientRetentionRateWidget: {
        title: "Patient Retention Rate",
        content: {
          subtitle: "Returning patients",
        },
      },
      startToPatientRatioWidget: {
        title: "Start-to-patient Ratio",
        content: {
          subtitle: "Consult -> Treatment",
        },
      },
      totalPracticesWidget: {
        content: {
          subtitle: "Recently added: {count}",
        },
      },
      treatmentStartsTrendWidget: {
        title: "Treatment Starts Trend",
      },
      treatmentStartsWidget: {
        title: "Treatment Starts",
        content: {
          subtitle: "Previous: {count}",
        },
      },
    },
  },
  annotation: {
    editor: {
      textFontSize: "Text Font size",
      strokeWidth: "Stroke Width",
      fillColor: "Fill color",
      strokeColor: "Stroke color",
      textColor: "Text color",
      fontFamily: "Font",
      cornerRadius: "Corners",
    },
    tooltip: {
      remove: "Remove selected (Del)",
      redo: "Redo (Ctrl+Shift+Z)",
      undo: "Undo (Ctrl+Z)",
      zoomFit: "Fit to screen",
    },
    tool: {
      line: "Line",
      rect: "Rect",
      circle: "Circle",
      arrow: "Arrow",
      text: "Text",
    },
    framing: {
      title: "Adjust image",
    },
  },
  billing: {
    balance: {
      title: "Balance",
      amountOwed: "Amount owed",
      noBalance: "No balance information available.",
      lastPayout: "Last payout",
      unpaidPayout: {
        failedNote: "It was not paid out, so the amount stays in your balance.",
        returnedNote: "Funds were returned to your balance.",
        failedLead: "Payout failed",
        returnedLead: "Payout returned",
        summary: "{lead}: {payout} to {method} ({amount}).",
        summaryNoMethod: "{lead}: {payout} ({amount}).",
        cancelledLead: "Payout cancelled",
      },
      recentPayouts: "Recent payouts",
      recentInvoices: "Recent invoices",
      recentTransactions: "Recent transactions",
    },
    paymentMethods: {
      expires: "Expires {date}",
      addCard: "Add Payment Method",
      setDefault: "Set as default",
      noPaymentMethods: "No payment method on file yet - add one before the trial ends.",
      stripeUnavailable: "Payment processing is currently unavailable. Please try again later.",
      payout: {
        notReady: "Not ready for payouts",
        notCapable: "Can't receive payouts",
        notCapableHint:
          "Credit cards can't receive payouts. Use a debit card or add a bank account.",
        notReadyHint:
          "This card can receive payouts once payout setup is finished and Stripe has prepared it.",
        notOffered: "Not available for payouts in {country}",
        bankNotReadyHint: "This bank account can't receive payouts. Add another one.",
        closed: "Account closed",
        closedHint:
          "The bank returned a payout because this account is closed or doesn't exist. Remove it and add another one.",
      },
      chooseKind: "What would you like to add?",
      kinds: {
        card: {
          description: "Pays invoices. A debit card can also receive payouts.",
        },
        bankAccount: {
          title: "US bank account (ACH)",
          description: "Receives payouts only, in 1-3 business days. It can't pay invoices.",
          notOffered: "Bank accounts aren't offered for payouts in this country yet.",
        },
      },
      setPayoutDefault: "Set as default for payouts",
      switchPayoutDefault: {
        title: "Switch the payout default?",
        message:
          "{current} can no longer receive payouts in this country. After you switch, you can't make it the default again.",
      },
      payoutDefaultMoved: "{name} is now the payout default.",
      funding: {
        debit: "Debit card",
        credit: "Credit card",
        prepaid: "Prepaid card",
        unknown: "Card",
      },
      added: "Added {date}",
      setDefaultForPayments: "Set as default for payments",
      removeFromBoth:
        "Are you sure you want to remove {entity}? It will be removed from both payments and payouts. This action cannot be undone.",
      payoutSectionTitle: "Payout Methods",
      addPayoutMethod: "Add Payout Method",
      noPayoutMethods: "No payout method yet.",
      payoutNoDestination: "Payouts have no destination until you add a payout method.",
    },
    billingHistory: {
      noInvoices: "No invoices yet.",
      statuses: {
        draft: "Draft",
        pending: "Pending",
        paid: "Paid",
        failed: "Failed",
        tax_failed: "Tax error",
        cancelled: "Cancelled",
        action_required: "Action Required",
      },
      failureUnknown: "Payment failed for an unknown reason.",
      taxFailureUnknown:
        "Tax could not be calculated for this invoice. Please check the billing address or contact support.",
      actions: {
        retry: "Retry Payment",
      },
      createInvoiceDialog: {
        quantity: "Quantity",
        lineTypes: {
          monthly_fee: "Monthly Fee",
          service_fee: "Service Fee",
          reimbursement: "Reimbursement",
        },
      },
      retryDefaultMethod: "The payment will be charged to your default payment method.",
      retryNoDefaultMethod: "Set a default payment method to retry this payment.",
    },
    invoiceDetail: {
      dueDate: "Due Date",
      products: "Products",
      noLineItems: "No line items.",
      summary: "Summary",
      amountDue: "Amount Due",
      downloadPdf: "Download as PDF",
      billedTo: "Billed to",
      terms: "Payment terms",
      netDays: "Net {days} - due {date}",
      subtotal: "Subtotal",
    },
    filters: {
      allStatuses: "Record type",
    },
    transactionHistory: {
      noTransactions: "No transactions yet.",
      moneyInAmount: "Money in: {amount}",
      moneyOutAmount: "Money out: {amount}",
      columns: {
        transaction: "Transaction",
      },
      kinds: {
        refund: "Refund",
        other: "Other",
      },
      titles: {
        invoicePaid: "Invoice paid",
        reimbursementTo: "Reimbursement to {name}",
        reimbursementFrom: "Reimbursement from {name}",
        tax: "Tax",
        taxNamed: "Tax: {name}",
        payoutWithdrawn: "Payout withdrawn from balance",
        payoutSettled: "Payout settled",
        payoutReversed: "Payout reversed to balance",
        payoutReturned: "Payout returned to balance",
      },
      openPayout: "Open payout {number}",
      openInvoice: "Open invoice {number}",
    },
    failureCodes: {
      payment_methods_error: "No valid payment method available.",
      no_default_payment_method: "No default payment method set.",
      tax_customer_tax_location_invalid:
        "We couldn't calculate tax - the billing address is invalid or incomplete. Please review and correct it.",
      charge_failed: {
        _self: "Payment charge failed.",
        acss_debit_session_incomplete: "ACSS debit session is incomplete.",
        api_key_expired: "API key has expired.",
        account_closed: "The bank account has been closed.",
        account_country_invalid_address: "Account country does not match the address.",
        account_error_country_change_requires_additional_steps:
          "Country change requires additional verification steps.",
        account_information_mismatch: "Account information does not match.",
        account_invalid: "The account is invalid.",
        account_number_invalid: "The account number is invalid.",
        account_token_required_for_v2_account: "An account token is required.",
        alipay_upgrade_required: "Alipay upgrade required.",
        amount_too_large: "The charge amount is too large.",
        amount_too_small: "The charge amount is too small.",
        application_fees_not_allowed: "Application fees are not allowed.",
        authentication_required: "Authentication is required to complete this charge.",
        balance_insufficient: "Insufficient balance to complete the charge.",
        balance_invalid_parameter: "Invalid balance parameter.",
        bank_account_bad_routing_numbers: "Invalid bank routing numbers.",
        bank_account_declined: "The bank account was declined.",
        bank_account_exists: "This bank account already exists.",
        bank_account_restricted: "The bank account is restricted.",
        bank_account_unusable: "The bank account cannot be used.",
        bank_account_unverified: "The bank account has not been verified.",
        bank_account_verification_failed: "Bank account verification failed.",
        billing_invalid_mandate: "The billing mandate is invalid.",
        bitcoin_upgrade_required: "Bitcoin upgrade required.",
        capture_charge_authorization_expired: "Charge authorization has expired.",
        capture_unauthorized_payment: "Unauthorized payment capture.",
        card_decline_rate_limit_exceeded: "Too many declined attempts. Please try again later.",
        card_declined: "The card was declined.",
        cardholder_phone_number_required: "Cardholder phone number is required.",
        charge_already_captured: "This charge has already been captured.",
        charge_already_refunded: "This charge has already been refunded.",
        charge_disputed: "This charge is under dispute.",
        charge_exceeds_source_limit: "Charge exceeds the source limit.",
        charge_exceeds_transaction_limit: "Charge exceeds the transaction limit.",
        charge_expired_for_capture: "The charge has expired and cannot be captured.",
        charge_invalid_parameter: "Invalid charge parameter.",
        charge_not_refundable: "This charge cannot be refunded.",
        clearing_code_unsupported: "Clearing code is not supported.",
        country_code_invalid: "Invalid country code.",
        country_unsupported: "This country is not supported.",
        coupon_expired: "The coupon has expired.",
        customer_max_payment_methods: "Maximum number of payment methods reached.",
        customer_max_subscriptions: "Maximum number of subscriptions reached.",
        customer_session_expired: "Customer session has expired.",
        customer_tax_location_invalid: "Invalid customer tax location.",
        debit_not_authorized: "Debit is not authorized.",
        email_invalid: "The email address is invalid.",
        expired_card: "The card has expired.",
        financial_connections_account_inactive: "The linked financial account is inactive.",
        financial_connections_account_pending_account_numbers:
          "Account numbers are pending for the linked account.",
        financial_connections_account_unavailable_account_numbers:
          "Account numbers are unavailable for the linked account.",
        financial_connections_no_successful_transaction_refresh:
          "Could not refresh transactions for the linked account.",
        forwarding_api_inactive: "Forwarding API is inactive.",
        forwarding_api_invalid_parameter: "Invalid forwarding API parameter.",
        forwarding_api_retryable_upstream_error: "Upstream error, please retry.",
        forwarding_api_upstream_connection_error: "Could not connect to upstream service.",
        forwarding_api_upstream_connection_timeout: "Upstream connection timed out.",
        forwarding_api_upstream_error: "Upstream service error.",
        idempotency_key_in_use: "Idempotency key is already in use.",
        incorrect_address: "The billing address is incorrect.",
        incorrect_cvc: "The card's security code (CVC) is incorrect.",
        incorrect_number: "The card number is incorrect.",
        incorrect_zip: "The postal code is incorrect.",
        india_recurring_payment_mandate_canceled: "Recurring payment mandate was canceled.",
        instant_payouts_config_disabled: "Instant payouts are disabled.",
        instant_payouts_currency_disabled: "Instant payouts are not available for this currency.",
        instant_payouts_limit_exceeded: "Instant payout limit exceeded.",
        instant_payouts_unsupported: "Instant payouts are not supported.",
        insufficient_funds: "Insufficient funds.",
        intent_invalid_state: "Payment intent is in an invalid state.",
        intent_verification_method_missing: "Verification method is missing.",
        invalid_card_type: "This card type is not supported.",
        invalid_characters: "Invalid characters in payment details.",
        invalid_charge_amount: "The charge amount is invalid.",
        invalid_cvc: "The card's security code (CVC) is invalid.",
        invalid_expiry_month: "The card's expiry month is invalid.",
        invalid_expiry_year: "The card's expiry year is invalid.",
        invalid_mandate_reference_prefix_format: "Invalid mandate reference prefix format.",
        invalid_number: "The card number is invalid.",
        invalid_source_usage: "Invalid source usage.",
        invalid_tax_location: "Invalid tax location.",
        invoice_no_customer_line_items: "Invoice has no customer line items.",
        invoice_no_payment_method_types: "Invoice has no valid payment method types.",
        invoice_no_subscription_line_items: "Invoice has no subscription line items.",
        invoice_not_editable: "This invoice can no longer be edited.",
        invoice_on_behalf_of_not_editable: "Invoice on behalf of cannot be edited.",
        invoice_payment_intent_requires_action:
          "Additional action is required to complete payment.",
        invoice_upcoming_none: "No upcoming invoice found.",
        livemode_mismatch: "Live/test mode mismatch.",
        lock_timeout: "Request timed out due to lock contention.",
        missing: "No card on file for this customer.",
        no_account: "No account found.",
        not_allowed_on_standard_account: "This operation is not allowed on a standard account.",
        out_of_inventory: "Item is out of inventory.",
        ownership_declaration_not_allowed: "Ownership declaration is not allowed.",
        parameter_invalid_empty: "A required parameter is empty.",
        parameter_invalid_integer: "A parameter contains an invalid integer.",
        parameter_invalid_string_blank: "A parameter contains a blank string.",
        parameter_invalid_string_empty: "A parameter contains an empty string.",
        parameter_missing: "A required parameter is missing.",
        parameter_unknown: "An unknown parameter was provided.",
        parameters_exclusive: "Mutually exclusive parameters were provided.",
        payment_intent_action_required: "Additional action required to complete payment.",
        payment_intent_authentication_failure: "Payment authentication failed.",
        payment_intent_incompatible_payment_method:
          "Payment method is incompatible with this payment.",
        payment_intent_invalid_parameter: "Invalid payment intent parameter.",
        payment_intent_konbini_rejected_confirmation_number:
          "Konbini confirmation number was rejected.",
        payment_intent_mandate_invalid: "Payment mandate is invalid.",
        payment_intent_payment_attempt_expired: "Payment attempt has expired.",
        payment_intent_payment_attempt_failed: "Payment attempt failed.",
        payment_intent_rate_limit_exceeded: "Too many payment attempts. Please try again later.",
        payment_intent_unexpected_state: "Payment is in an unexpected state.",
        payment_method_bank_account_already_verified: "Bank account is already verified.",
        payment_method_bank_account_blocked: "This bank account has been blocked.",
        payment_method_billing_details_address_missing: "Billing address is missing.",
        payment_method_configuration_failures: "Payment method configuration error.",
        payment_method_currency_mismatch: "Payment method currency does not match.",
        payment_method_customer_decline: "Payment was declined by the customer.",
        payment_method_invalid_parameter: "Invalid payment method parameter.",
        payment_method_invalid_parameter_testmode: "Invalid parameter for test mode.",
        payment_method_microdeposit_failed: "Microdeposit verification failed.",
        payment_method_microdeposit_verification_amounts_invalid:
          "Microdeposit verification amounts are invalid.",
        payment_method_microdeposit_verification_amounts_mismatch:
          "Microdeposit verification amounts do not match.",
        payment_method_microdeposit_verification_attempts_exceeded:
          "Too many microdeposit verification attempts.",
        payment_method_microdeposit_verification_descriptor_code_mismatch:
          "Microdeposit descriptor code does not match.",
        payment_method_microdeposit_verification_timeout: "Microdeposit verification timed out.",
        payment_method_not_available: "This payment method is not available.",
        payment_method_provider_decline: "Payment was declined by the provider.",
        payment_method_provider_timeout: "Payment provider timed out.",
        payment_method_unactivated: "This payment method has not been activated.",
        payment_method_unexpected_state: "Payment method is in an unexpected state.",
        payment_method_unsupported_type: "This payment method type is not supported.",
        payout_reconciliation_not_ready: "Payout reconciliation is not ready.",
        payouts_limit_exceeded: "Payout limit exceeded.",
        payouts_not_allowed: "Payouts are not allowed.",
        platform_account_required: "A platform account is required.",
        platform_api_key_expired: "Platform API key has expired.",
        postal_code_invalid: "The postal code is invalid.",
        processing_error: "An error occurred while processing the payment.",
        product_inactive: "The product is inactive.",
        progressive_onboarding_limit_exceeded: "Progressive onboarding limit exceeded.",
        rate_limit: "Too many requests. Please try again later.",
        refer_to_customer: "Please refer to your customer for payment.",
        refund_disputed_payment: "Cannot refund a disputed payment.",
        request_blocked: "The request was blocked.",
        resource_already_exists: "This resource already exists.",
        resource_missing: "A required resource is missing.",
        return_intent_already_processed: "This return has already been processed.",
        routing_number_invalid: "The routing number is invalid.",
        secret_key_required: "A secret key is required.",
        sepa_unsupported_account: "This SEPA account is not supported.",
        setup_attempt_failed: "Payment setup attempt failed.",
        setup_intent_authentication_failure: "Setup authentication failed.",
        setup_intent_invalid_parameter: "Invalid setup intent parameter.",
        setup_intent_mandate_invalid: "Setup mandate is invalid.",
        setup_intent_mobile_wallet_unsupported: "Mobile wallet is not supported for setup.",
        setup_intent_setup_attempt_expired: "Setup attempt has expired.",
        setup_intent_unexpected_state: "Setup intent is in an unexpected state.",
        shipping_address_invalid: "The shipping address is invalid.",
        shipping_calculation_failed: "Shipping cost calculation failed.",
        sku_inactive: "This SKU is inactive.",
        state_unsupported: "This state is not supported.",
        status_transition_invalid: "Invalid status transition.",
        stripe_tax_inactive: "Stripe Tax is not activated.",
        tax_id_invalid: "The tax ID is invalid.",
        tax_id_prohibited: "Tax ID is not allowed.",
        taxes_calculation_failed: "Tax calculation failed.",
        terminal_location_country_unsupported: "Terminal location country is not supported.",
        terminal_reader_busy: "Terminal reader is busy.",
        terminal_reader_hardware_fault: "Terminal reader hardware fault.",
        terminal_reader_invalid_location_for_activation:
          "Invalid location for terminal activation.",
        terminal_reader_invalid_location_for_payment: "Invalid location for terminal payment.",
        terminal_reader_offline: "Terminal reader is offline.",
        terminal_reader_timeout: "Terminal reader timed out.",
        testmode_charges_only: "Only test mode charges are allowed.",
        tls_version_unsupported: "TLS version is not supported.",
        token_already_used: "This token has already been used.",
        token_card_network_invalid: "Card network is invalid for this token.",
        token_in_use: "This token is currently in use.",
        transfer_source_balance_parameters_mismatch:
          "Transfer source balance parameters do not match.",
        transfers_not_allowed: "Transfers are not allowed.",
        url_invalid: "The URL provided is invalid.",
      },
    },
    intervals: {
      title: "Plan History",
    },
    coupon: {
      title: "Coupon Code",
      placeholder: "Enter coupon code",
      comingSoon: "Coupon codes are not available yet.",
    },
    payouts: {
      payTo: "Pay to",
      noPayouts: "No payouts yet.",
      failureUnknown: "The payout did not go through.",
      setupMissing: "Payouts are not set up for this account yet.",
      disabledReasons: {
        setupMissing:
          "Payouts aren't set up yet. Add a bank account under Payment methods to set them up.",
        notVerified: "Stripe hasn't verified who receives the payouts yet.",
      },
      actions: {
        recheck: "Check Status",
        retry: "Retry Payout",
      },
      statuses: {
        pending: "Pending",
        processing: "Processing",
        posted: "Paid",
        failed: "Failed",
        cancelled: "Cancelled",
        returned: "Returned",
      },
      refusalCodes: {
        insufficient_balance: "The balance is too low for this payout.",
        recipient_not_active:
          "Payouts are not active for this account yet. Finish the payout setup first.",
        payouts_disabled: "Payouts are turned off for this account.",
        no_recipient: "No payout recipient is set up for this account.",
        method_not_eligible: "This payout method cannot receive payouts.",
        currency_not_supported: "This payout method does not support the selected currency.",
        payout_method_not_found: "The selected payout method no longer exists. Choose another one.",
        payout_method_type_not_offered:
          "This type of payout method is not offered in the recipient's country.",
        platform_balance_too_low: "Payouts are temporarily unavailable. Please try again later.",
        provider_error:
          "The payment provider could not process the payout. Please try again later.",
        provider_declined: "The payment provider declined the payout.",
        recipient_email_does_not_exist:
          "The recipient has no email address. Add it, then send the payout again.",
        invalid_bank_account:
          "The bank rejected these account details. Check the numbers and try again.",
        method_cannot_pay:
          "A bank account can't pay invoices, so it can't be the default payment method.",
        payment_method_in_use:
          "A payout to this payment method is still on its way. You can remove it once the payout arrives.",
        payment_method_not_found: "This payment method no longer exists.",
        recipient_address_required:
          "A business recipient needs a full address: street, city and ZIP code.",
        recipient_error:
          "Stripe didn't accept the recipient details, so nothing was saved. Check them and try again.",
        identity_error:
          "Payouts couldn't be set up for this account right now, so nothing was saved. Try again later.",
      },
      accessDenied: "Only a billing manager of this account can send payouts.",
      setupLoadFailed: "Payout details couldn't be loaded. Try again later.",
      missingEmail: "Add the recipient's email. Stripe can't send payouts without it.",
      recipientDetailsIncomplete:
        "Some recipient details are missing. Add them so payouts keep working.",
      detail: {
        reason: "Reason",
        bankReturnNote:
          "A bank payout can still come back within a few business days after it's paid.",
        processingHint: "The status updates by itself while the payout is on its way.",
        unknownReason: "The payout did not go through. Check your bank details.",
      },
      providerFailureCodes: {
        payout_method_does_not_exist:
          "The bank couldn't find this account. Check the account and routing number.",
        payout_method_closed:
          "This bank account has been closed. Add a different account for payouts.",
        payout_method_restricted:
          "This account can't receive payouts right now. Use a different payout method.",
        payout_method_currency_unsupported:
          "This payout method doesn't support this currency. Choose another method or currency.",
        payout_method_invalid_account_number:
          "The bank rejected this account number. Check the details and try again.",
        payout_method_holder_name_incorrect:
          "The name on the bank account doesn't match. Update the account holder details.",
        payout_method_holder_address_incorrect:
          "The address on the bank account is incorrect. Update the account details.",
        payout_method_holder_details_incorrect:
          "The bank account holder details are incorrect. Update them and try again.",
        payout_method_canceled_by_customer: "The recipient canceled this payout.",
        recalled: "This payout was recalled before it arrived.",
        payout_method_declined: "The payout method declined this payment.",
        payout_method_expired: "This payout method has expired. Add a new one and try again.",
        payout_method_unsupported: "This payout method isn't supported for this transfer.",
        payout_method_usage_frequency_limit_exceeded:
          "Too many payouts were sent to this method. Try again later.",
        payout_method_amount_limit_exceeded:
          "This payout exceeds the limit for this method. Try a smaller amount.",
      },
    },
    payoutSetup: {
      steps: {
        verify: {
          title: "Verify identity",
        },
      },
      status: {
        pending: "Verification in progress",
        restricted: "Stripe needs more information",
        verified: "Identity verified",
        notVerified: "Not verified yet",
      },
      actions: {
        checkAgain: "Check again",
        fixDetails: "Fix details",
      },
      pendingHint: "Stripe is reviewing the details. This page updates by itself when it's done.",
      recipient: {
        saved: "Payout details saved",
        emailHint: "Stripe emails a notice to this address for every payout.",
        companyName: "Company name",
        stripeSetup: "Stripe setup",
        saveFailed: "Payout details weren't saved. {reason}",
      },
      restrictedMissingDetailsHint:
        "Some recipient details are missing. Fix them to finish verification.",
      restrictedHint: "Stripe needs more information to verify this recipient. Contact support.",
      notOfferedHint: "Payouts aren't available for recipients in {country}.",
    },
    bankAccount: {
      title: "Add a US bank account",
      subtitle: "Payouts will be sent here by ACH transfer.",
      paidTo: "Paid to",
      routingNumber: "Routing number",
      routingNumberHint: "9 digits, on a check or in your banking app",
      accountNumber: "Account number",
      accountType: "Account type",
      checking: "Checking",
      savings: "Savings",
      arrivalNote:
        "Arrives in 1-3 business days. We don't store your account number; it goes straight to our payment provider.",
      save: "Save bank account",
      added: "Bank account added",
      errors: {
        routingNumberLength: "Routing number must be 9 digits.",
        invalidRoutingNumber: "This routing number isn't valid.",
        accountNumberLength: "Account number must be 4 to 17 digits.",
        unknownOutcomeBlocked:
          "We couldn't confirm whether the bank account was added. Use Check status. If it still isn't listed, reload the page before adding it again.",
      },
    },
    ownerType: "Billing account type",
  },
  connections: {
    suspendReason: "Reason (optional)",
    suspendTitle: "Suspend connection",
    connectionWith: "Connection with {name}",
    revokeAll: "Revoke all",
    title: "Connected practices",
    subtitle: "What you can do with each practice",
    youInvited: "You invited",
    invitedYou: "Invited you",
    notRegistered: "Not registered yet",
    connected: "Connected",
    notYet: "Not yet",
    draftContract: "Draft contract",
    blockers: {
      contractNotSigned: "Contract is not signed yet",
      contractCancelled: "Contract was cancelled",
      contractEnded: "Contract has ended",
      notActingParty: "Only the initiating practice can use this",
      connectionSuspended: "Connection is suspended",
      partnerNotSigned: "Partner has not signed yet",
    },
    unavailable: "Unable to use",
    detail: {
      contractsTitle: "Connection agreements",
      invites: "Invitations",
      waitingForThem: "Waiting for their signature",
      waitingForYou: "Waiting for your signature",
      noContracts: "No contracts for this connection yet.",
    },
    registrationFilter: {
      registered: "Registered",
      notRegistered: "Not registered",
    },
  },
  practicePlan: {
    trialBanner: {
      title: "Free Trial active - {daysLeft} days left",
      subtitle:
        "Converts to {planName} ({price}/mo) on {conversionDate} unless changed. Add a payment method before it ends.",
      addPaymentMethod: "Add Payment Method",
      subtitleReady: "Converts to {planName} ({price}/mo) on {conversionDate} unless changed.",
    },
    widget: {
      metadata:
        "Practice plan · {officeCount} offices · Trial → converts to {planName} ({daysLeft}d left)",
      connections: "Connections {used} / {total}",
      changePlan: "Change plan",
      pricePerMonth: "{price}/mo",
    },
    badges: {
      mostPopular: "Most Popular",
    },
    changePlan: {
      title: "Practice Plan",
      currentPlanLabel: "Current plan (practice-level)",
      choosePlan: "Choose a plan for this practice",
      confirmPlan: "Confirm Plan",
      requestDowngrade: "Request Downgrade",
      downgradeWarning:
        "Downgrading will reduce your connection pool and may affect active office links. Your request will be reviewed before taking effect.",
      effectiveDateLabel: "Effective date",
      effectiveDateHint: "Leave blank to apply the change immediately.",
      stats: {
        poolUsed: "Pool used",
        billingCycle: "Billing cycle",
        nextBillDate: "Next bill date",
        nextEstimate: "Next estimate",
        monthlyFee: "Monthly fee",
        nextBillingCycle: "Next billing cycle",
      },
      requestSubmitted: "Downgrade request submitted.",
      planUpdated: "Practice plan updated.",
      sharedPool: "Shared pool of {count} connections",
      noCompanyCountry:
        "This practice has no country set, so only plans offered in every country can be selected. Set the practice country to see country-specific plans.",
      noPlansTitle: "Looking for a different plan?",
      noPlansBody:
        "There are no self-serve plans to switch to right now. Get in touch and we’ll find the right fit for your practice.",
    },
    tiers: {
      launch: {
        name: "Launch Network",
        description: "Small practices starting their network",
        price: "$199 / month",
        features: {
          pool: "Shared pool of 5 connections",
          support: "Email support",
        },
      },
      growth: {
        name: "Growth Network",
        description: "Most popular for growing practices",
        price: "$349 / month",
        features: {
          pool: "Shared pool of 15 connections",
          support: "Priority support",
        },
      },
      enterprise: {
        name: "Enterprise Network",
        description: "Established multi-provider practices",
        price: "$549 / month",
        features: {
          pool: "Shared pool of 30 connections",
          support: "Dedicated support",
        },
      },
      custom: {
        name: "Custom Plan",
        description: "DSOs & large orgs - click to get a quote",
        contactUs: "Contact us",
        flexiblePool: "Flexible pool",
        features: {
          pool: "30+ pooled connections",
          dashboard: "DSO dashboard",
          slIncluded: "SL2 & SL3 included",
          volumeDiscounts: "Volume discounts",
        },
      },
    },
    dsoBilling: {
      activeTitle: "Billed by the DSO since {date}",
      activeSubtitle: "While the DSO covers this practice, its plan is changed at DSO level.",
      start: "Bill through DSO",
      stop: "Stop DSO billing",
      startDescription:
        "From the selected date the DSO is billed for {company} instead of the practice itself.",
      stopDescription:
        "The DSO covers {company} up to and including the selected date. From the day after, the practice is billed for its own plan again.",
      started: "DSO billing started.",
      stopped: "DSO billing stopped.",
    },
  },
  backoffice: {
    subscriptionRequests: {
      title: "Subscription Requests",
      subtitle: "Review pending subscription change requests.",
      noAccess: "You don't have access to manage subscription requests.",
      pending: {
        title: "Pending requests",
        empty: "No pending requests.",
        upgrade: "Upgrade",
        downgrade: "Downgrade",
        productChange: "{from} → {to}",
        connectionsChange: "{from} → {to} connections",
      },
      startMso: {
        title: "Start MSO subscription",
        subtitle: "Give an MSO its first subscription product.",
        action: "Start subscription",
        success: "MSO subscription started.",
      },
    },
    customPlans: {
      title: "Custom Plans",
      subtitle: "Manage MSO subscriptions and their custom-plan change requests.",
      noAccess: "You don't have access to manage custom plans.",
      noListAccess:
        "You don't have access to view the custom plan list, but you may still be able to add one.",
      detail: {
        pendingChange: "Pending change request",
        noPendingChange: "No pending change request.",
        requestedProduct: "Requested product",
      },
      create: {
        subtitle:
          "Creates the plan and submits it as a change request for the chosen DSO, which then waits for approval.",
        msoCountry:
          "This DSO is registered in {country}. The plan must be offered there, or the DSO cannot be subscribed to it.",
      },
      review: {
        title: "Review Custom Plan",
        freeTrial: "Free trial",
      },
      pendingTitle: "Pending review",
      pendingEmpty: "No custom plans awaiting review.",
      activeTitle: "Active custom plans",
      linkFailed:
        "The plan was created but could not be linked to that DSO - you have to be one of its responsible persons. The plan is listed in the backoffice plan catalogue.",
      noSubscription:
        "This DSO has no subscription yet, so there is nothing to propose a change against. Its first plan has to be started before a custom plan can go through approval.",
      startFirstPlan:
        "This DSO has no subscription yet. Creating this plan starts it as their first subscription, effective immediately - there is no approval step.",
      startFailed:
        "The plan was created but the DSO's first subscription could not be started. The plan is listed in the backoffice plan catalogue.",
    },
  },
  integrations: {
    title: "Integrations",
    providers: {
      title: "Providers",
      connected: "Connected",
      itero: "iTero",
      iteroDescription: "Intraoral scanner provider",
    },
    iteroOAuth: {
      successTitle: "connected!",
      successText:
        "Your iTero account has been successfully linked. Redirecting to Settings in {seconds} seconds",
      failureTitle: "Connection failed",
      retry: "Retry",
      processing: "Connecting your Itero account...",
      errors: {
        missingStateOrCode: "Missing state or code parameters in callback URL.",
        invalidPayload: "iTero authorization failed or returned invalid data.",
        invalidState: "Authorization state is invalid or expired. Please reconnect from Settings.",
        providerPayload: "iTero returned an unexpected payload. Please try again.",
        generic: "OAuth callback failed. Please try again.",
      },
    },
  },
  privacyPolicy: {
    title: "PRIVACY POLICY",
    effectiveDate: "Effective Date: April 14, 2025",
    intro:
      "CoTreatMe, LLC (“CoTreatMe” “us,” “we” or “our”) have created this Privacy Policy (“Policy”) in compliance with applicable laws and in order to demonstrate our firm commitment to privacy of your information. This Policy describes how CoTreatMe collects, uses, discloses, transfers, stores, retains or otherwise processes your information when you (whether in your individual or business capacity) access or use, in any manner, any of our content, products, services or related activities (collectively “Services”), including through our cotreatme.com Internet domain (the “Site”).",
    youMeans:
      "When we refer to “you” or “your,” we mean the person about whom we collect personal information or data. If the person accessing the Site or engaging with our Services does so on behalf of, or for the purposes of, another person, including a business or other organization, “you” or “your” also means that other person, including a business organization, if applicable.",
    readCarefully: "Please read this Policy carefully. Our Policy includes:",
    sections: {
      security: "SECURITY",
    },
    generalDisclosures: {
      title: "GENERAL DISCLOSURES",
      hosting:
        "Our data centers and Site are hosted in the United States. If you are visiting this Site from outside of the United States, please note that by providing us your information it is being stored or processed in the United States where our data center and servers are located and operated. The United States may not have privacy laws that are as strong or comprehensive as the privacy laws in your own country. If you are outside the United States and do not wish to allow the collection and storage of your personal information within the United States, you should not use this Site and you should opt-out of online tracking and the collection of cookies by following the guidelines in our section titled How To Opt-Out Of Tracking And Restrict Cookies.",
      healthLaws:
        "There are federal laws that may entitle you to additional disclosures and rights regarding the collection and disclosure of certain kinds of health-related data.",
      onlyThisPolicy:
        "This Policy applies only to CoTreatMe’s Site and Services, and not to other companies’ or organizations’ websites, mobile applications and services to which we link. We are not responsible for the privacy practices of other businesses or the content of other websites, including any websites that may indicate a special relationship or partnership with us (such as co-branded pages or “in cooperation with” relationships). To ensure protection of your privacy, always review the privacy policy of the companies with whom you engage.",
    },
    infoCollection: {
      title: "WHAT INFORMATION WE COLLECT AND DISCLOSE AND FOR WHAT PURPOSES",
      context:
        "In the course of operating our Site and performing our Services, we collect a variety of different kinds of personal information in different contexts. What information we collect and the purposes for which it is collected will depend on the context of our activities or the Service that is being performed. Therefore, just because this Policy lists a particular data collection practice does not mean that we have necessarily collected that data from you. Instead, please review the applicable disclosures below to learn about how we may have collected personal information from you depending on how you have interacted with us.",
      visitOrUseIntro: "When you visit or use our Site, we may collect your:",
      visitOrUse: {
        list: {
          onlineIdentifier:
            "Online identifier information, such as your internet protocol (IP) address and other unique identifiers (like cookies);",
          geolocation: "Geolocation information;",
          internetActivity:
            "Internet activity information, such as the sub-pages you look at and how you interact with our Site; and",
          deviceInfo:
            "Device information, such as your operating system, browser and other technology on the devices that you use to access the Site.",
        },
      },
      whyWeCollectThis: "We collect this information in order to:",
      whyWeCollectThisList: {
        accessSite: "Provide you with access to the Site;",
        secureNetworks: "Secure our networks, systems and databases against external threats;",
        siteAnalytics: "Perform general Site analytics and monitor Site usage;",
        developEnhance: "Develop, maintain and enhance our Sites and Services; and",
        advertising:
          "To advertise our Services, including through targeted or interest-based advertising. You can read more about our use of tracking technologies in our section titled: Cookies and Online Technologies Policy.",
      },
      discloseTo: "We may disclose this information to our:",
      discloseToList: {
        serviceProviders:
          "Service providers (marketing services vendors, security monitoring providers, data analytics providers, database and hosting vendors);",
        pluginEntities: "Entities that operate plug-ins or social media features on our Sites; and",
        adPartners: "Online advertising and marketing partners.",
      },
      enterInfoIntro:
        "If you enter information into our Site, we may collect your (or your dependent’s or responsible party’s):",
      enterInfo: {
        list: {
          identifier: "Identifier information, such as your full name and date of birth;",
          location: "Location information, such as your zip code; and",
          payment:
            "Payment information, such as your payment card number, payment or banking information.",
        },
        whyList: {
          connectProviders: "Connect you with providers, including scheduling appointments;",
        },
        discloseToList: {
          serviceProviders:
            "Service providers (security monitoring providers, data analytics providers, database and hosting vendors); and",
        },
      },
      engageServicesIntro:
        "If you engage with our Services, we may collect your (or your dependent’s or responsible party’s):",
      engageServices: {
        list: {
          identifier: "Identifier information, such as your full name, date of birth and gender;",
          contact: "Contact information, such as your address, phone number and e-mail;",
          payment:
            "Payment information, such as your payment card number, payment or banking information;",
          insurance: "Insurance information; and",
          voice: "Voice recordings, from our customer service interactions.",
        },
        whyList: {
          provideServices: "Provide you with requested Services;",
          connectProviders: "Connect you with providers;",
          improveAI:
            "Improve our artificial intelligence voice recognition software via our customer service calls;",
          developEnhance: "Develop, maintain and enhance our Services;",
          processTransactions: "Process transactions with you; and",
          contactAboutServices: "Contact you with information about our Services.",
        },
        discloseToList: {
          serviceProviders:
            "Service providers (data analytics providers, database and hosting vendor); and",
          connectedProviders: "Providers with whom you are connected.",
        },
      },
      smileAppIntro:
        "If you engage with our Smile Simulation App as part of our Services, we may collect your (or your dependent’s or responsible party’s):",
      smileApp: {
        list: {
          login: "Login information, such as your username and password;",
          contact: "Contact information, such as your phone number and e-mail;",
          visual: "Visual information, such as a photo of your mouth.",
        },
        why: {
          login:
            "We collect your login information to provide you with access to the Smile Simulation App.",
          identifierContactLocation:
            "We collect your identifier, contact and location information to:",
          identifierContactLocationList: {
            connectDental: "Connect you with dental providers;",
            market: "Market and advertise our Services and products to you;",
            contactAboutServices: "Contact you with information about our Services and products.",
          },
          visual:
            "We collect your visual information to provide our Services to you through the Smile Simulation App.",
        },
        disclose: {
          login:
            "We may disclose your login information to the third-party application provider and our security providers.",
          identifierContactLocation:
            "We may disclose your identifier, contact and location information to:",
          identifierContactLocationList: {
            serviceProviders:
              "Our service providers (security monitoring providers, data analytics providers, database and hosting vendors; communication platform providers);",
            applicationProvider: "Our third-party application provider;",
            marketingPartners: "Our marketing and advertising partners; and",
            dentalProviders: "Dental providers.",
          },
        },
        visualCollectedByThirdParty:
          "Your visual information may be collected directly by our third-party application provider, who may use this information to improve their artificial intelligence software and tools, pursuant to the terms and privacy policy presented to you upon signup with the Smile Simulation App. CoTreatMe has no responsibility or control over this third-party application provider’s use of your information.",
      },
      furtherDisclosuresIntro:
        "In addition, any information you provide may be disclosed to other entities in the circumstances described below:",
      auditors:
        "To our auditors. We may be subject to audits from a number of entities as well as due to our own internal auditing policies. In order to accomplish an effective audit, we must provide information, which may include your personal information, to external auditors. We always ensure that your information is safely disclosed and stored and that auditors can only use your information for the purposes of completing an audit.",
      authorizedEntities:
        "To individuals or entities you authorize. We may disclose your personal information to individuals or entities at your direction.",
      affiliates:
        "To our affiliates. We may share your personal information with our affiliates for the purposes of administering our business and providing our Services.",
      corporateTransactions:
        "In corporate transactions. We may share all or part of your personal information with other entities in connection with the sale, assignment, merger or other transfer of all or a portion of our organization or assets to such entities (including due to a sale in connection with a bankruptcy).",
      legalPurposes:
        "For legal purposes. We may disclose all or part of your personal information to courts, litigants, regulators, arbitrators, administrative bodies or law enforcement when we have reason to believe that disclosing this information is necessary to resolve actual or suspected claims. We may also disclose your personal information in order to identify, contact or bring legal action against someone who may be violating any agreement with us, or may be causing injury to or interference with (either intentionally or unintentionally) our rights or property, other users of the Site, or anyone else that could be harmed by such activities. We may disclose information in response to a subpoena, search warrant, in connection with judicial proceedings, or pursuant to court orders, legal process or other law enforcement measures.",
      aggregatedInfo:
        "Finally, we may process your personal information into aggregated, anonymized or de-identified form for any purpose. Aggregated, anonymized or de-identified information is information that can no longer reasonably identify a specific individual and is no longer “personal information.”",
    },
    cookiesPolicy: {
      title: "COOKIES AND ONLINE TECHNOLOGIES POLICY",
      whatIsCookie: "What is a cookie?",
      whatIsCookieDesc:
        "A cookie is a small text file that is placed on your hard drive by a web page server. Cookies contain information that can later be read by a web server in the domain that issued the cookie to you. There are several types of cookies:",
      types: {
        session:
          "Session cookies provide information about how a website is used during a single browser session while a user is visiting a website. Session cookies usually expire after the browser is closed.",
        persistent:
          "Persistent cookies remain on your device between different browser sessions for a set amount of time in order to enable the website to remember user preferences, settings, or actions across other sites.",
        firstParty:
          "First-party cookies are cookies set by the operator of the website you are visiting.",
        thirdParty:
          "Third-party cookies are cookies set by third-parties that are different from the operator of the website you are visiting.",
      },
      ourCollection: "Our collection of cookies",
      ourCollectionDesc:
        "We, our marketing partners, affiliates, and analytics or service providers use cookies and other similar technologies. We group the cookies that we collect into the following categories based upon their function (note that all types of cookies, as described above, may be found in each category):",
      table: {
        essential: "Essential Cookies",
        essentialDesc:
          "Essential cookies are sometimes called “strictly necessary” as without them we cannot operate and administer the Site.",
        analytics: "Analytics Cookies",
        analyticsDesc:
          "These cookies track information about visits to the Sites so that we can make improvements and report our performance. For example: analyze visitor and user behavior so as to provide more relevant content or suggest certain activities.",
        personalization: "Personalization Cookies",
        personalizationDesc:
          "During your visit to the Sites, cookies are used to remember information you have entered or choices you make (such as your username, language or your region) on the Sites. They also store your preferences when personalizing the Sites to optimize your use of the Site.",
        targeting: "Targeting or Advertising Cookies",
        targetingDesc:
          "These Third-party Cookies are placed by third-party advertising platforms or networks in order to deliver ads and track ad performance, enable advertising networks to deliver ads that may be relevant to you based upon your activities (this is sometimes called “behavioral” “tracking” or “targeted” advertising) on the Sites. They may subsequently use information about your visit to target you with advertising that you may be interested in, on the Sites and other websites.",
      },
      thirdPartyCookies: {
        title: "Third-party cookies",
        desc: "The Site allows third-parties to place cookies on your Internet-connected device in order to deliver advertisements based upon your web-browsing habits and history. Further, in order to provide interoperability and plug-ins from various social media websites (like Facebook), the Site allows these third-parties to place and collect cookies on your Internet-connected device. However, you can restrict the third-party collection of cookies through the instructions provided in the section How To Opt-Out Of Tracking And Restrict Cookies below.",
      },
      analytics: {
        desc1:
          "We may use service providers to provide Site metrics and other analytics services. These service providers may use cookies (see above); web beacons (also called clear GIFs or pixels), which are small blocks of code that allow us to measure the actions of visitors using CoTreatMe’s Sites; and other technologies to collect information, such as your IP address, identifiers associated with your device, other applications on your device, the browsers you use to access our Sites and Services, webpages viewed, time spent on webpages, links clicked and conversion information (e.g., transactions entered into).",
        desc2:
          "This information may be used by CoTreatMe and its service providers on behalf of CoTreatMe to analyze and track usage of our Sites and Services to determine the popularity of certain content and to better understand how you use our Sites and Services.",
        googleAnalytics:
          "We use Google Analytics on the Site to analyze how individuals use the Site. We will package up information about how individuals interact with our Site and send it to Google Analytics to be processed into reports. This information includes basic pageviews and visit data such as device type, operating system, and browser type. When Google Analytics processes data, it aggregates and organizes the data based on particular criteria like whether a user’s device is mobile or desktop, or which browser they’re using. If, at any time, you choose not to participate in the use of analytics software, please use your web browser’s available opt-outs as described in the section How To Opt-Out Of Tracking And Restrict Cookies.",
      },
      advertising: {
        title: "Advertising",
        desc1:
          "We also have partnered with third-party advertising networks that collect information about your online web browsing habits to serve you with interest-based advertisements. The information collected about you to serve these ads can include your IP address, unique online identifiers, your activity on our Sites and information about your operating system, browser and platform and other technology on the devices you use to access the sites.",
        desc2:
          "For example, we use Google Analytics Advertising cookies to identify what advertisements you see when you browse the Internet and how you have interacted with them. We may use this information for our own advertising or it could be pooled together by Google from your interactions with other websites to determine what kind of advertisements you may see on the Internet.",
        desc3:
          "We also partner with Microsoft Clarity and Microsoft Advertising to capture how you use and interact with the Site through behavioral metrics, heatmaps, and session replay to improve and market our products/services. Site usage data is captured using first and third-party cookies and other tracking technologies to determine the popularity of products/services and online activity. Additionally, we use this information for the Site optimization, fraud/security purposes, and advertising. Microsoft’s privacy policy can be located here.",
        desc4:
          "The Meta Pixel is a snippet of code that sends data back to Meta about people who use these sites and allows us to provide custom advertising on Meta properties (like Facebook and Instagram). The data provided to Meta may include information about how you interact with our Sites, including your search queries.",
      },
      accessibilityWidget: {
        title: "Accessibility Widget",
        desc: "You can use the accessibility widget on the Site to improve the accessibility of the content provided therein. Your Site preferences may be stored in the form of cookies on your device and collected by our Site on your re-visit.",
      },
      dnt: {
        title: "Do Not Track",
        desc: "Do Not Track (“DNT”) is an optional browser setting that allows you to express your preferences regarding tracking across websites. Most modern web browsers give you the option to send a Do Not Track signal to the websites you visit, indicating that you do not wish to be tracked. However, there is no accepted standard for how a website should respond to this signal, so we do not take any action in response to this signal. CoTreatMe does not have a mechanism in place to respond to DNT signals. Instead, in addition to publicly available external tools, we offer you the choices described in this Policy to manage the collection and use of information about you.",
      },
      webBeacons: {
        title: "Web beacons, pixels, tags and scripts",
        desc1:
          "In addition to cookies, we use other technologies to recognize and track visitors to CoTreatMe’s Sites. A web beacon (also known as a “tracking pixel” or “clear GIF”) is a clear graphic image (typically a one-pixel tag) that is delivered through a web browser or HTML email, typically in conjunction with a cookie. Web beacons allow us certain functionality, for example, monitoring how users move from one page within a website to another, to track access to our communications, to understand whether users have come to a website from an online advertisement displayed on a third-party website, to measure how ads have been viewed and to improve site performance.",
        desc2:
          "These technologies may be used on our sites or in our emails to help us to deliver cookies, count visits, understand usage of our sites, campaign effectiveness and determine whether an email has been opened.",
      },
      socialMediaPlugins: {
        title: "Social Media Plug-ins (Facebook, Instagram and TikTok)",
        desc: "These plug-ins allow us to integrate social media functions into CoTreatMe’s Site and may also be used for advertising purposes by those social media companies. If you visit our Site while logged into your social media accounts, information about your visit to our Sites, your social media identifier and information about your browser may be provided to those third-party social media companies. You should review the privacy policy of any social media entity with whom you have an account to learn about how they may use your data.",
      },
      optOut: {
        title: "How To Opt-Out Of Tracking And Restrict Cookies",
        desc: "You can opt-out of the tracking of your online behavior by:",
        list: {
          cookiePrefs:
            "Accessing the Cookie Preferences feature on our Site and disabling “Targeted Advertising” cookies and ensuring that “Do Not Sell or Share My Personal Information” is toggled on;",
          nai: "Visiting the Network Advertising Initiative (NAI) website opt-out page: ",
          daa: "Visiting the Digital Advertising Alliance (DAA) opt-out page: ",
          googlePlugin:
            "Downloading and installing the Google browser plug-in from the following link: ",
        },
      },
      browserControl:
        "You can control and delete cookies through your browser settings through the following:",
      browserControlList: {
        chrome: "Google Chrome",
        firefox: "Mozilla Firefox",
        safari: "Safari",
        opera: "Opera",
        ie: "Microsoft Internet Explorer",
        edge: "Microsoft Edge",
        safariIos: "Safari for iOS (iPhone and iPad)",
        chromeAndroid: "Chrome for Android",
      },
      restrictingWarning:
        "Please be aware that restricting cookies may impact the functionality of the Site. For example, refusing cookies will not allow CoTreatMe to remember your log-in information or accessibility preferences. Additional general information about cookies, including how to be notified about the placement of new cookies and how to disable cookies, can be found at www.allaboutcookies.org.",
      ftcFirst: "Alternatively, you may visit the U.S. Federal Trade Commission’s ",
      ftcSecond:
        " to obtain comprehensive general information about cookies and how to adjust the cookie settings on various browsers.",
    },
    childrenInfo: {
      title: "PERSONAL INFORMATION RELATING TO CHILDREN",
      desc: "It is our policy to refrain from knowingly collecting or maintaining personal information relating to any person under the age of 13. The Children’s Online Privacy and Protection Act (COPPA) regulates online collection of information from persons under the age of 13. Therefore, if you are under the age of 13, please do not supply any personal information through the Site. If you are under the age of 13 and have already provided personal information through the Site, please have your parent or guardian contact us immediately using the information provided under Contact Us.",
    },
    marketing: {
      title: "MARKETING AND PROMOTIONAL COMMUNICATIONS",
      desc: "You may opt-out of receiving marketing and promotional messages from us, if those messages are powered by us, by following the instructions in those messages. If you decide to opt-out, you will still receive non-promotional communications that are necessary in the performance of our Services.",
    },
    integrations: {
      title: "INTEGRATIONS AND LINKS TO OTHER SITES",
      desc: "This Policy applies only to our Site, and not to other companies’ or organizations’ websites to which we link from our Site. CoTreatMe is not responsible for the privacy practices or the content of such websites or organizations, including any websites that may indicate a special relationship or partnership with us (such as co-branded pages or “powered by” or “in cooperation with” relationships). Other linked websites may collect personal information from you that is not subject to our control. To ensure protection of your privacy, always review the privacy policy of the websites you may visit.",
    },
    security: {
      desc: "We take reasonable measures, including administrative, technical, and physical safeguards, to protect your information from loss, theft, misuse, and unauthorized access, disclosure, alteration, and destruction. We hold information about you at our own premises and with the assistance of service providers. Further public disclosure here of our security measures could aid those who might attempt to circumvent those security measures. If you have additional questions regarding security, please contact us directly using the information provided under Contact Us.",
    },
    caRights: {
      title: "YOUR CALIFORNIA PRIVACY RIGHTS",
      desc1:
        "Residents of the State of California may ask us to provide them with a list of the types of personal information that we have disclosed during the preceding year to third-parties for their direct marketing purposes, and the identity of those third-parties. If you are a California resident and would like such a list, or would like to opt-out of future disclosures, please contact us at the addresses provided in Contact Us.",
      desc2:
        "For all such requests, please indicate “CA Shine the Light” in the subject field of your request and include the name of the CoTreatMe service with respect to which you are requesting the information.",
    },
    changes: {
      title: "CHANGES TO THIS PRIVACY POLICY",
      desc: "We may amend this Policy at any time by posting revisions on our Site. If we make any material changes in the way we collect or process your personal information, we will notify you by prominently posting notice of the changes on our Site.",
    },
    contact: {
      title: "CONTACT US",
      desc: "To submit questions, you can contact us by:\nCalling us toll-free at 1 (877) 221-9008; or\nEmailing us directly at",
    },
  },
  cotreatmeInvitation: {
    metaTitle: "CoTreatMe Invitation",
    thesis: {
      line1: "The future of dentistry isn't competition.",
      line2: "It's {emphasis}",
      emphasis: "collaboration.",
    },
    title: {
      line1: "You're invited to CoTreatMe",
      line2: "the collaborative network.",
    },
    lead: "CoTreatMe connects general dentists and specialists on one platform to refer, communicate, and treat patients together, without friction.",
    benefits: {
      referrals: {
        title: "Referrals that never get lost",
        text: "Send and receive referrals in seconds via QR, NFC, or manual entry, and track every case in real time.",
      },
      revenue: {
        title: "A new revenue stream, without the risk",
        text: "Deliver specialist quality care with orthodontist oversight and earn reimbursement for clinical record services.",
      },
      coTreat: {
        title: "CoTreat cases together",
        text: "Plan with specialists, deliver simple steps in office, and stay the trusted face of care for your patients.",
      },
      compliant: {
        title: "Fully compliant by design",
        text: "No fee splitting. Service based remuneration with transparent, auditable payment flows.",
      },
    },
    actions: {
      label: "Respond to invitation",
    },
    footnote: "You can always be invited again later.",
    snackbar: {
      declined: "Invitation declined.",
    },
  },
  contracts: {
    cotreatment: {
      signedTitle: "Your CoTreatment agreement is signed",
      signedText: "Cotreatment cases can be created with your partner practices.",
      unsignedTitle: "You have not signed the CoTreatment agreement",
      unsignedText: "Sign it to start cotreating cases with your partner practices.",
      pendingTitle: "Your CoTreatment agreement is awaiting signature",
      pendingText: "We have sent it for signature. Check your email to review and sign it.",
    },
  },
} as const;

export type FeaturesMessages = typeof features;
